import reasons from './reasons'

export default {
  name: 'BaseInfoReason',
  path: 'reason',
  meta: {
    label: 'reason',
    auth: 'reason'
  },
  component: {
    name: 'Reason',
    render(c) {
      return c('router-view')
    }
  },
  children: [reasons]
}
